import * as types from '../../actions/actionsTypes/tipiAttivitaActionsType'
import {printOnlyInDevelopment} from "../../fanctionUtility";

export const initialStateTipiAttivita = {
    attivita : [],
    allAttivita : [],
    valoreAggiornato : null,
    nuovaAttivita : null,
    error : []
};

export const tipoAttivitaReducer = ( state = initialStateTipiAttivita, action ) => {

    switch (action.type) {

        case types.GET_ATTIVITA_BY_TIPO_CORSO_SUCCESS : {
            printOnlyInDevelopment('Get attivita by tipo corso success :: ', action.attivita);
            return {
                ...state,
                attivita : action.attivita,
                error: []
            };
        }

        case types.GET_ATTIVITA_BY_TIPO_CORSO_FAIL : {
            printOnlyInDevelopment('Get attivita by tipo corso fail ::', action.error);
            return {
                ...state,
                error: [ ...state.error, action.error ]
            }
        }

        case types.INIT_ATTIVITA_BY_TIPO_CORSO : {
            printOnlyInDevelopment('Inizialization Tipi Attivita');
            return {
                attivita : [],
                allAttivita : [],
                valoreAggiornato : null,
                nuovaAttivita : null,
                error : []
            };
        }

        case types.GET_ALL_TIPI_ATTIVITA_SUCCESS : {
            printOnlyInDevelopment( 'Get all type activities success :: ', action.tipiAttivita );
            return {
                ...state,
                allAttivita : action.tipiAttivita,
                error : []
            };
        }

        case types.GET_ALL_TIPI_ATTIVITA_FAIL : {
            printOnlyInDevelopment( 'Get all type activities error :: ', action.error );
            return {
                ...state,
                error : [ ...state.error, action.error ]
            };
        }

        case types.UPDATE_SUCCESS : {
            return {
                ...state,
                valoreAggiornato : action.attivitaUpdated
            };
        }

        case types.INSERT_TIPO_ATTIVITA_SUCCESS : {
            return {
                ...state,
                nuovaAttivita : action.nuovaAttivita
            }
        }

        case types.INIT_UPDATE_FIELDS : {
            if ( state.valoreAggiornato || state.nuovaAttivita ) {
                return {
                    ...state,
                    valoreAggiornato : null,
                    nuovaAttivita : null
                }
            } else {
                return state;
            }

        }

        default: {
            return state;
        }
    }
};


